import React               from 'react';
import { Route, Routes } from 'react-router-dom';
import { Schedule }        from './Schedule';

export const ScheduleRoutes = () => (
  <Routes>
    <Route
      path="/:eventMonth?"
      element={<Schedule />}
    />
  </Routes>
);
